import { ULI_LAYER_CONFIG } from '../unified_login/config.js';

const internalDeviceOutput = window.TCMS.viewtype;
const deviceOutput = window.TCMS.externalViewtype;
const event = internalDeviceOutput === 'desktop' ? 'mouseenter' : 'load';
const event2 = 'touchend'; // RECTSA-5045 - Wireframe hat ein preventDefault eingebaut, was den Click abfängt und auf tablet nur auf touchend hört. Daher hier doppelt
const selector = internalDeviceOutput === 'desktop' ? '#c24-header-top .c24-contact' : '.c24m-contact-wrapper';
let chattyInitExecuted = false;
let isShowChat = true;

let contactContainer = document.querySelector(selector);

// reset contact container, prevent chatbox event
if (window?.TCMS?.showChat === 0) {
    isShowChat = false;
}

const controlServerAddressMapping = {
    de: {
        dev: 'https://api.chat.check24-int.de',
        int: 'https://api.chat.check24-int.de',
        staging: 'https://api.chat.check24-test.de',
        production: 'https://api.chat.check24.de'
    },
    at: {
        dev: 'https://api.chat.check24-int.de',
        int: 'https://api.chat.check24-int.de',
        staging: 'https://api.chat.check24-test.de',
        production: 'https://api.chat.check24.at'
    }
};

if (window?.Check24?.contact?.isContactLayerEnabled !== undefined) {
    window.Check24.contact.isContactLayerEnabled = false;
}

if (window?.C24M?.contact?.isContactLayerEnabled !== undefined) {
    window.C24M.contact.isContactLayerEnabled = false;
}

const locationSearch = location.search || null;
const urlSearchParams = new URLSearchParams(locationSearch);

function executeChattyInit() {
    if (chattyInitExecuted) {
        return;
    }

    chattyInitExecuted = true;

    import('./tcms_chatty.js')
        .then(({ chattyInit }) => {
            let options = {
                deviceoutput: deviceOutput,
                controlServerAddress:
                    controlServerAddressMapping[window.TCMS.language][window.TCMS.env] || 'https://api.chat.check24.de',
                chatFlowName: 'mietwagen.chat_flow',
                chatFlowEntry: 'start_from_startpage',
                contactLink: 'https://www.check24.de/unternehmen/kontakt/?sec=mwa',
                showButton: true
            };

            chattyInit(options);

            if (Check24.uliloginlayer) {
                Check24.uliloginlayer.init(ULI_LAYER_CONFIG);
            }
        })
        .catch((err) => console.error(err));
}

if (isShowChat) {
    executeChattyInit();
}

const eventListener = (e) => {
    executeChattyInit();
};

if (contactContainer && isShowChat) {
    contactContainer.addEventListener(event2, eventListener, {
        once: true,
        passive: true,
        capture: true
    });

    contactContainer.addEventListener(event, eventListener, {
        once: true,
        passive: true,
        capture: true
    });
}

// init for ?showchat=1
if (urlSearchParams.get('showchat') === '1' && isShowChat) {
    executeChattyInit();
}
